var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonPlusActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 8.75H17.5M17.5 8.75H20.125M17.5 8.75V6.125M17.5 8.75V11.375",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 17.5V16.625C0.875 13.2423 3.61726 10.5 7 10.5C10.3827 10.5 13.125 13.2423 13.125 16.625V17.5",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5C8.93296 10.5 10.5 8.93296 10.5 7C10.5 5.067 8.93296 3.5 7 3.5C5.067 3.5 3.5 5.067 3.5 7C3.5 8.93296 5.067 10.5 7 10.5Z",
    stroke: "#0092DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPlusActive);
export default __webpack_public_path__ + "static/media/person_plus_active.f613b1291c109f066f0cb608cbaea7d8.svg";
export { ForwardRef as ReactComponent };